
<template>
  <v-container fluid>
    <h2>
      <small class="cyan--text">New</small>
    </h2>
    <v-form v-model="valid" ref="form">
      <v-layout wrap>
        <v-row>
          <v-col :cols="12">
            <v-row>
              <v-col :cols="12" sm="6" md="4">
                <v-text-field v-model="item.name" :rules="rules.field" label="Name*"></v-text-field>
              </v-col>
              <v-col :cols="12" sm="6" md="4">
                <v-text-field v-model="item.description" label="Description" ></v-text-field>
              </v-col>
              <v-col :cols="12" sm="12" md="8">
                <v-autocomplete label="Users" v-model="selectedUsers" :items="users" filled chips item-text="blueTag" item-value="id" multiple>
                  <template v-slot:selection="data">
                    <user-chip close :text="data.item.blueTag" @click:close="remove(data.item)"></user-chip>
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-avatar><img :src="avatarData"></v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-text="data.item.blueTag"></v-list-item-title>
                      <v-list-item-subtitle v-text="data.item.fullName"></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-col :cols="12">
          <v-tabs v-model="activeTab">
            <v-tab href="#Projects">Projects</v-tab>
            <v-tab href="#Categories">Categories</v-tab>
            <v-tab href="#Permissions">Permissions</v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item
              value="Projects"
            >
              <v-card flat>
                <v-card-text class="px-0">
                  <v-col :cols="12" lg="9" xl="8" class="ml-2">
                    <v-row>
                      <v-col cols="5">
                        <v-text-field
                          flat
                          outlined
                          solo
                          prepend-inner-icon="search"
                          placeholder="Search"
                          v-model="search"
                          hide-details
                          class="hidden-sm-and-down"
                          deletable
                        ></v-text-field>
                      </v-col>
                      <v-col cols="7">
                        <div class="float-right">
                          <v-flex xs12 class="text-sm-left">
                            <label class="filter-label ml-2">Project Status</label>
                            <br />
                            <v-slide-group multiple left show-arrows v-model="selectedStatuses" class="slide-group-left">
                              <v-slide-item v-for="status in statuses" :key="status.id" v-slot:default="{ active, toggle }">
                                <v-btn class="ma-1" :input-value="active" depressed active-class="primary" small @click="toggle" >
                                  {{status.name}}
                                </v-btn>
                              </v-slide-item>
                            </v-slide-group>
                          </v-flex>
                        </div>
                      </v-col>
                    </v-row>

                  </v-col>

                  <v-col :cols="12" lg="9" xl="8" class="elevation-2 ml-2">
                    <div class="line header">
                      <div class="line-title">Name</div>
                      <div class="content">
                        <div class="item-title">Visibility</div>
                        <div class="item-title">Can Edit</div>
                        <div class="item-title">Can Report</div>
                        <div class="item-title">Delete Work Items</div>
                      </div>
                    </div>

                    <div class="line select-all-container">
                      <div class="content">
                        <div class="item-title">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small class="ml-1 project-toggle-btn" @click="selectAll('view')"
                                v-on="on" :class="viewLevelOptions[selectAllStates['viewLevel']].textClass" :text="true" input-value="true"><v-icon>{{viewLevelOptions[selectAllStates['viewLevel']].icon}}</v-icon></v-btn>
                            </template>
                            <span>
                              <span v-text="viewLevelOptions[selectAllStates['viewLevel']].tooltip"></span>
                            </span>
                          </v-tooltip>
                        </div>

                        <div class="item-title">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small class="ml-1 project-toggle-btn" @click="selectAll('edit')"
                                v-on="on" :class="editLevelOptions[selectAllStates['editLevel']].textClass" :text="true" input-value="true"><v-icon>{{editLevelOptions[selectAllStates['editLevel']].icon}}</v-icon></v-btn>                    
                            </template>
                            <span>
                              <span v-text="editLevelOptions[selectAllStates['editLevel']].tooltip"></span>
                            </span>
                          </v-tooltip>
                        </div>

                        <div class="item-title" v-if="!item.type">
                          <v-tooltip top v-if="!item.type">
                            <template v-slot:activator="{ on }">
                              <v-btn small class="ml-1 project-toggle-btn" @click="selectAll('report')"
                                v-on="on" :class="reportLevelOptions[selectAllStates['reportLevel']].textClass" :text="true" input-value="true"><v-icon>{{reportLevelOptions[selectAllStates['reportLevel']].icon}}</v-icon></v-btn>                    
                            </template>
                            <span>
                              <span v-text="reportLevelOptions[selectAllStates['reportLevel']].tooltip"></span>
                            </span>
                          </v-tooltip>
                        </div>

                        <div class="item-title">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small class="ml-1 project-toggle-btn" @click="selectAll('delete')"
                                v-on="on" :class="editLevelOptions[selectAllStates['deleteLevel']].textClass" :text="true" input-value="true"><v-icon>{{editLevelOptions[selectAllStates['deleteLevel']].icon}}</v-icon></v-btn>                    
                            </template>
                            <span>
                              <span v-text="deleteLevelOptions[selectAllStates['deleteLevel']].tooltip"></span>
                            </span>
                          </v-tooltip>
                        </div>
                      </div>
                    </div>

                    <v-expansion-panels v-model="expandedPanel" flat focusable accordion active-class="selected-project">
                      <v-expansion-panel v-for="(project, ix) in shownProjects" :key="project.id" >
                        <v-expansion-panel-header disable-icon-rotate class="panel-header">
                          <div>
                            <v-icon>{{ expandedPanel == ix ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                            {{project.name}}
                          </div>
                          <template v-slot:actions>
                            <div class="item-title">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-btn small class="ml-1 project-toggle-btn" @click.stop="handleViewChange(project)"
                                    v-on="on" :class="viewLevelOptions[project.viewLevel].textClass" :text="true" input-value="true"><v-icon>{{viewLevelOptions[project.viewLevel].icon}}</v-icon></v-btn>                    
                                </template>
                                <span>
                                  <span v-text="viewLevelOptions[project.viewLevel].tooltip"></span>
                                </span>
                              </v-tooltip>
                            </div>

                            <div class="item-title">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-btn small class="ml-1 project-toggle-btn" @click.stop="project.canEdit = editLevelOptions[project.canEdit].nextValue"
                                    v-on="on" :class="editLevelOptions[project.canEdit].textClass" :text="true" input-value="true"><v-icon>{{editLevelOptions[project.canEdit].icon}}</v-icon></v-btn>                    
                                </template>
                                <span>
                                  <span v-text="editLevelOptions[project.canEdit].tooltip"></span>
                                </span>
                              </v-tooltip>
                            </div>

                            <div class="item-title" v-if="!item.type">
                              <v-tooltip top v-if="!item.type">
                                <template v-slot:activator="{ on }">
                                  <v-btn small class="ml-1 project-toggle-btn" @click.stop="project.canReport = reportLevelOptions[project.canReport].nextValue"
                                    v-on="on" :class="reportLevelOptions[project.canReport].textClass" :text="true" input-value="true"><v-icon>{{reportLevelOptions[project.canReport].icon}}</v-icon></v-btn>                    
                                </template>
                                <span>
                                  <span v-text="reportLevelOptions[project.canReport].tooltip"></span>
                                </span>
                              </v-tooltip>
                            </div>

                            <div class="item-title">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-btn small class="ml-1 project-toggle-btn" @click.stop="project.canDelete = editLevelOptions[project.canDelete].nextValue"
                                    v-on="on" :class="editLevelOptions[project.canDelete].textClass" :text="true" input-value="true"><v-icon>{{editLevelOptions[project.canDelete].icon}}</v-icon></v-btn>                    
                                </template>
                                <span>
                                  <span v-text="deleteLevelOptions[project.canEdit].tooltip"></span>
                                </span>
                              </v-tooltip>
                            </div>
                          </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="panel-content">
                          <div
                            class="line" v-for="(subpermission, ix) in projectSubpermissions" :key="ix"
                            v-show="subpermission.persistent || project.tabs.some(t => t.tab == subpermission.value && t.show)"
                          >
                            <div class="line-title">{{subpermission.name}}</div>
                            <div class="content">

                              <div class="item-title">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      small class="ml-1 project-toggle-btn" @click="tabChange(project, subpermission.value)"
                                      v-on="on" :class="viewLevelOptions[project.tabs[subpermission.value].viewLevel].textClass" :text="true" input-value="true"
                                    >
                                      <v-icon :class="viewLevelOptions[project.tabs[subpermission.value].viewLevel].textClass">{{viewLevelOptions[project.tabs[subpermission.value].viewLevel].icon}}</v-icon>
                                    </v-btn>
                                  </template>
                                  <span v-if="project.tabs && project.tabs.length && project.tabs[subpermission.value]">
                                    {{ (viewLevelOptions[project.tabs[subpermission.value].viewLevel] || {}).tooltip }}
                                  </span>
                                </v-tooltip>
                              </div>

                            </div>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              value="Categories"
            >
              <v-card flat>
                <v-card-text class="px-0" style="width: 600px">
                  <v-col :cols="12" class="px-0">
                    <v-list subheader>
                      <v-list-item v-for="category in categories" :key="category.id">

                        <v-list-item-title>
                          <span>{{category.name}}</span>
                        </v-list-item-title>
                        <PermissionButtons 
                            :viewOnly="false"
                            :value="category"
                            attr="viewLevel"
                            type="ViewLevelOptions"
                            @input="(newCategory) => {category = newCategory}"
                          />
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item
              value="Permissions"
            >
              <v-card class="ml-1" flat>
                <v-card-text class="px-0" style="width: 600px">
                  <v-expansion-panels
                    v-model="expandedPanel"
                    focusable accordion
                    active-class="selected-project elevation-2"
                    class="permissions"
                  >
                    <v-expansion-panel v-for="(permission) in permissions" :key="permission.id" :readonly="!permission.children">
                      <v-expansion-panel-header  class="panel-header">
                        <div>
                          {{permission.name}}
                        </div>
                        <template v-slot:actions>
                          <div v-if="!permission.children">
                            <access-level-select
                              :value="getPermissionByValue(permission.value).accessLevel"
                              :type="permission.levelTypes"
                              @input="(v) => {
                                if(permission){
                                  let pem = getPermissionByValue(permission.value)
                                  pem.accessLevel = v
                                }
                              }"
                            />
                          </div>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="panel-content" v-if="permission.children">
                        <div class="line" v-for="(subpermission, ix) in permission.children" :key="ix">
                          <div class="line-title">{{subpermission.name}}</div>
                          <div class="content">
                            <access-level-select
                              :value="getPermissionByValue(subpermission.value).accessLevel"
                              :type="subpermission.levelTypes"
                              @input="(v) => {
                                let pem = getPermissionByValue(subpermission.value)
                                pem.accessLevel = v
                              }"
                            />
                          </div>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
        <v-flex xs12>
          <p class="text-sm-right">
            <v-btn class="mx-2" color="default" to="/userGroup">
              Cancel
            </v-btn>
            <v-btn color="accent" @click="save" >
              Save
              <v-icon right>cloud_upload</v-icon>
            </v-btn>
          </p>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import _ from "lodash"
import {
  ViewLevelOptions, 
  EditLevelOptions, 
  DeleteLevelOptions, 
  ReportLevelOptions, 
  PermissionsOptions
} from '../../enums/permissions';
import permissionsJSON from '../../json/permissions.json'
import PermissionButtons from "../../components/PermissionButtons"
import AccessLevelSelect from '../../components/AccessLevelSelect'

let avatarData = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD//gA7Q1JFQVRPUjogZ2QtanBlZyB2MS4wICh1c2luZyBJSkcgSlBFRyB2NjIpLCBxdWFsaXR5ID0gNzUK/9sAQwAIBgYHBgUIBwcHCQkICgwUDQwLCwwZEhMPFB0aHx4dGhwcICQuJyAiLCMcHCg3KSwwMTQ0NB8nOT04MjwuMzQy/9sAQwEJCQkMCwwYDQ0YMiEcITIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIy/8AAEQgBDgEOAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A9g6AEDnqTR356+1B6ZHFBA6YOf5UAKAM9KbgE4ozg9etDc5/rQAoGTjvjBoPc8n6UYIGfxpBxn396AF6/nQcEYBoPb+7R1zk/iKAD06Zo/mehoz34FHUADBoAUH16ikB656duKX+LoDSd+lACH5uoo3de+etKRnB6+2KTjHXke1AC59eKOo6jGaOgOMYNBGB70ALxgZPekHQ56e9KeRj2pCPlPrQAZxmg59hRnPIxR/OgAweucgdKAMng0DgnnikGfT3zQA5hk/40YANHfr3ppPPQ0AOyc+3vTe+M4P86Xk9wD9OaONpz1FAB0x2NGR0zRwTxzQVOQfzoAQn14HpSnG7GOBQD1+vrQeme3XNABxkfrigE4/WjgnFBOD69MDFAAQRg559KVenPT86Qg5Izz1zS5A+lACZxnPJpccj0pMcc8/SgdRuGSaADdgjnHajrnPWkHH40HHsO+aAFHBzxnrRyOQaB83OaOOTgUAHbOfxoPTkUgyRQSf8aAFPHPqKNwBoxwD29KUcHsQKAAn36U3HGPxpeewOKF46EmgA4/Ic8UEjJ4FHOeaX8KAEyMZHpSDp/Oq91qFnYLm5uY4/RWPJ/CsafxlpcOVj8+X3VAB+tAHRHH58Udhjk1yTeOrcH5bGQj3kA/pTk8d2xwHspQP9lgaAOsIH4ik7H/GsK38W6VcMN0rwk/8APRen4jNbME8FzH5kMqSp/eUgigCQY60D0/GgdB096B1+nWgAz3xyOlKR2oxkj+VJnn36UAHb2owc9frRnHB/KjbxQAYPrxR2zSYyen0o6gH+fegA56HtS59s5o7cDB60p5waAEB575oOD70YwRmjIyaADBOfT2oPPBBNLwOM0ANgjnOaAEydpJ/Sj2xSE4OaU8HGelACY4460YG7OKXOQeg+tA6ccUAIB2FKOPejI644o9+1AB069aBkmjIzxxRz0J+lAC+n6Uc5pP4s80ntmgBT65+lIOSe3qKU5x1qlqmqW+k2ZnmySeEQdWNAEl7f22n25muZQijp6n2A71xOqeMLu6LRWWbaD1H3z+PasbUdSudUuTPcPk/wqOij0FVKAFd2kYs7FmPUk5JpKKKACiiigAqW3up7SQSQTPG47qcVFRQB2WkeMvmWHU1Hp5yj+Yrr45EljEkbhkYZVl5zXj1bWg+IJtIlEbkvasfmT+77igD0leopvY5/OkgmS4iWaFw8bDKsPSpOgPegAHTkYpCM8+/XFGePWjB6c/WgAJ7Cgjk5xj6Uc444pTnoetACH7ozRn6/Q0ufXNIOnIIoAC2Omc9KF4x6UDrnPajHXmgA6dfyoBzjNHbNIwOeOtAC9GwaD+tGQBwMZoPoQfWgBBk5/rSn6dKUZAIP+FJkH6jpQAHGMnpR15H5UHrn9KCO5bigA+mcUbuCMc0dD06mjjqM0AL296Qjj9c0c/0pR2HT2oAjmkSCB5ZGCogLMT0Ary/WdVk1a/aZsrGOI0/uj/Gum8aakY4I7CMgGT55Mf3ew/P+VcTQAUUUUAFFFFABRRRQAUUUUAFFFFAHTeEtba0uRYTN+4mPyEn7jf8A1673AxweK8cBIOQea9P8P6idT0iOVjmVTsk+o/zmgDUyB0P40cEn1+tITjjmgg5P86AAnt/Sl5PH86Occ8mgcH3NABkZxR1+npSDpxxS9sE/pQAE9MUenqaCeKOg56e1ACEHIHT8aODxgevNL2z3/Ol5+lACHjqaM/Lg/nQRjpzR70AIc5pRw1A256Uc8c/WgAAx2oHv+FB79+9IAcCgAxjp0/lRyc9zS9vx/OgnP/66AE70p6849qMZHINNfIjYgc0AeX69dG81u6kzkK5RfoOKzqdLnznz13Gm0AFFFFABRRRQAUUUUAFFFFABRRRQAV1Xge6KX09oT8ske8D3B/wP6VytbXhMn/hIbfHcNn8qAPSTzzxSnnoMUnPGPzxR1GD0oAD2/PNGMHvzRxjJ57Uuce5oAQcd8UgJ9AfWl4oI/LqKAFzjHakGMdc0gPt0pRyMenegBenPf2oCryMkUnJz0zRkAcnn2FAC9iTmkOfx60YJJ9+wo/h5/nQADnrnjuaPvdQaBk4xwKT0Hr1oAXHoOfWkpc8+vpS5yxoAQjtQKByP5UEYPrQAY5x3oxg84x2pM5BxS4HSgDyK7XZezr6SMP1qGrWpADVbwDp57/8AoRqrQAUUUUAFFFFABRRRQAUUUUAFFFFABW94OXdr6k87Y2NYNdH4Kx/brHHIgbH5igD0AE+maOe340DGPegY/E0AHXPAFAP60DpznFLgHnH9KAGnpmlzQDnI70hwPxoAcTzwaTBOcmjHUD1oyeh470AAzxSclcgDrSjstJtJJFAC985xQBk0mTg8fjSqeOCPrQAdcg8D60HO7mjGPf0pD74zQApzg84NHqPWlzjGP1pD1zjNAC8DjuaT7vrQRkZ70ZI60AGOM9M/pQSBnIx36UfzzXP+LdTew05YoWKyznbkdl70AcNqf/IVvP8Aru//AKEaq0detFABRRRQAUUUUAFFFFABRRRQAUUUUAFdH4Kx/bcnOD5DY+u5a5ypIJ5LadJoXKSIcgigD1/I4zSnAwRwPeqemXo1DTYLngGRRn2PernXJHP1oAaWBHP/ANejOODnGKXtnOaB070AA9Qe1HUEHOaXoM5waQngZz+dABycGjrke9HPUelID8vIIoAUDj8aMnqKARnPb2pNxGcGgBe/40Yx9KPTkAetJ2x0zzQAo9RigDByBQfu9AKDwOOaAEJ9s0pyeSeBRjkDtR7DpigA6+tA5zxRk46/ShRg8jn0oAXdgcjFcT46B82xOcja/wDSu1GCckc1y/ja2MmmQ3AHMUmGx2Df/XoA4SiiigAooooAKKKKACiiigAooooAKKKKACiiigD0jwhuHh2Dryz4/wC+jW3zjHv2qho1s1po1rCw5EYLD0J5P86v/h+NACk880hwOnHuKB2zSk8YFADdw+ppQAGxmjJPUcml6EgHigBOB7UZ7f1pfbGfxpF+7g96AE79T9aDxS5P0x0FBB/+uKAD8f8A61J0PXP9KO/rjtSnOeOOO1ABxnHajg/nRnH0oA6YNACnufwpOh55+lIe/Bz60o7YyKAE9KU89utKD27ik6dKAAYzjmoLu0jvbWW2lBKSLg+v1qx/dpAeOM0AeY6r4fvdKdi8ZkgzxKgyMe/pWVXsLIkkZVgCpGCDyCK8p1O1Flqdzbj7schC/Tt+lAFSiiigAooooAKKKKACiiigAooooAACTgDJNdNoPhe5nuI7m9jMUCkNsYYZ/wAOwqPwbZpc6u0sihlgTcM+p4H9a9AzjOOlADsDGPypO+R2ozz3/wAaXqMjoRQAn8WRx3yaXoOc0hbBHUDvijPGCKAEJBOPWlPTpxRuA/lQcD+XBoAOeKOaMZwemKBkE+9AC5PrScDp+nNHbGc8cUfU/wBaAEwDz60vc+9LnOT6e1NHqOf0oAUZPvnmjGeSf160D+f6UdAKAD19aXJ4Hekx6nmjoeaAA9M8/jSgcf4UnQcYwaM4xmgBTkH2pB6HigdTn6mjvntnqaADOGrz3xlbeTrInA4nQH8Rx/hXoIOCSOPesLxbppvdIMyLmW3O/A647/59qAPOqKKKACiiigAooooAKKKKACiinwxPPMkUYy7sFUe5oA7jwRamLTprkg/vnwPov/1ya6jH1+lV9PtFsbCG1TpGoGffvVjJJHNABgg46Cgnnp0pD1GDSjuRzQAoJzxn3pOOv8qBwP8AGkBwPegBw60m70496TAHWlwD16/WgBQeewpOP8ijPGKOwGKAE+8eacoyxpF6Adf60fp364oAM9PUd6Wk9OaM47c9eKADgjtye9HGaOnHUgd6b3oAcM9+n5UE5OaACexIoJweRQAZ44FH0oGDxjr6UAHBxznrQAh4IP58U48+wHSkxt7UEjg+lABjrwKTAOc4IIxj2pe/HWjo3X2oA818SaR/ZeoExj/R5ssnt6isavRPGMAk0JpCBujdWB/T+ted0AFFFFABRRRQAUUUUAFdl4O0cBDqc656rCPT1b+lcaBkgV63ZxLb2UEKcKkYX9KAJ+Pr9aU4xgAc0E5P+NHXrigBD2x0xxSnG4UmeOlLyAemaAEOSfSlPXI/I0owRz/Kk/hHI/GgA5ByT+VISTwPzFKRx2/GkH3ulACjJPI7UD+dKPXqKT1NACgnGTnrmgdMjP0oxwf6UhIHXkUAHQnnmgcEn3NB4pMcHgdKAF4HSkPQ0o7cj3oGMUABGMUDpjPWjpx1oz1xkGgA9jijrzk0nfJH4UoPHQ0AHPbP40cdcD/CjkAk/WjpjHXFAB3z3oxnFGMjGOKXtg5xQBh+LGA8PT57so/WvN67rxxdqthBag/NI+8j2A/xP6VwtABRRRQAUUUUAFFFFACqcMD716/D88CEHqox+VeP16loV0LvRbWUHLBArc9xwaANDHGM8+9Lxkc0uMgCkyRkY5oAOc+xNHp6e9HcZHJpePwoATd+Xeg4xz/+qjjGB2oPJ70AGTt6/higHjPt6UAcdTSdz1HrQA4+h60h447fSg8etHXB9KAF6dsc0BuuAM0g5/8Ar0vQ8nH40AIe9AJIxx0o/i6GjgNnvQAYPA9e4PFJ06Y4pW4xzz60YPrigBMcdAKX+LntQMk8Y/GjPTH8qADGc+npS9D1NN478Uuc9Qc4oADlvQfjRnA5NIec+vvUc1xDbJvmkSNRyWdsCgCUckcVBe3sGn2zz3L7EX9T6Vz2o+M7WAFLGMzyf324Uf41x1/qV1qU3m3Mpc9h0C/QUASavqUmq6g9y4wv3UX+6vYVRoooAKKKKACiiigAooooAK6Dwxrq6ZMbe5J+yyHOf7jetc/RQB7EjrIiupBVhkEdDQe2f1rzHStfvdKIWNhJD3ifkfh6V2Wn+K9PvsLI/wBnlJ+7Jwv50AbuOSAMH60Yye/vg9aQMGUFSCD0IORS4wcdfwoAQYzyKUe1BAJzyKUH9KAE6Hrj1ozn8T1oznJHpQeOKAAjtQSMDHNH48+1HXjHNACAHpnGKXqMd/U0mBj69RS8dzj0oAAfeg88e1AOMjv0+lHcnj3oAATxg8UYO7NGOMetLxj1FACEY/8ArUH9OtUL3WdPsBm4uY93dAdzfkK5y98cHBSxtsD+/L/gP8aAOy4VMkgfpWPfeJdLscqZhK4/gi5P59K4G91a/wBQz9puXdf7mcL+QqlQB09940u5hss4UgXpuPzN/hXPXN3cXcm+4nklb1Zs1DRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAXLLVr7T2Btrl0A/hzlfyNdJY+NyMLfW2T08yI/0NcfRQB6rZazYaiMW9yjN/cJw35Gry4Jx2xjmvHK1bHxJqdjhUuDJGP4JPmH+NAHp+c5/lScDORz71ytj42tZMLeQNC395PmX/GuitL62vU3W08cg6nacn8R2oAsdBxz70AZOc/rQAefWjn0NABwcUvA55I9RSAdSP170ZP0+poATtnqKbLLFBG0ksiog6sxxiuf1rxZDYM1vaqJrgcEk/Kn+JriL3UbvUJd91O0h7A9B9BQB2uoeMrK3ZltFa4fGM/dWuYvvEup3+Q05ijPGyL5Rj69ayKKAAkk5JyaKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKdHLJC4eJ2Rx0ZTgim0UAdBYeMNRtNqzkXMY/v8N+ddRp3inTb3CFzBKf4ZOBn69K83ooA9jHPIPHX60mQRXmGma/f6YQIpS8PeJ+VP8Ah+Fd1pOvWerQkr8ky8tG55H0PcUAeZdTnvRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUAkHIJB9qKKACiiigAooooAKKKKACiiigAooooAKKKSgBaKKSgBaKSigBaKKSgBaKSloAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAP/Z"

export default {
  props: ["id"],
  components: { 
    PermissionButtons,
    AccessLevelSelect,
  },
  data: () => ({
    activeTab: 1,
    valid: false,
    item: { 
      active: true,
      canCreateProjects: PermissionsOptions.DEFAULT_KEY,
      canEditCategories: PermissionsOptions.DEFAULT_KEY,
      canEditUsers: PermissionsOptions.DEFAULT_KEY,
      canViewReports: PermissionsOptions.DEFAULT_KEY,
      permissions: [],
    },
    users: [],
    categories: [],
    projects: [],
    viewLevelOptions: {
      [ViewLevelOptions.CANNOT_VIEW_BY_DEFAULT.key]: ViewLevelOptions.CANNOT_VIEW_BY_DEFAULT.properties,
      [ViewLevelOptions.CAN_VIEW.key]: ViewLevelOptions.CAN_VIEW.properties,
      [ViewLevelOptions.CAN_NOT_VIEW.key]: ViewLevelOptions.CAN_NOT_VIEW.properties,
    },
    editLevelOptions: {
      [EditLevelOptions.CANNOT_EDIT_BY_DEFAULT.key]: EditLevelOptions.CANNOT_EDIT_BY_DEFAULT.properties,
      [EditLevelOptions.CAN_EDIT.key]: EditLevelOptions.CAN_EDIT.properties,
      [EditLevelOptions.CAN_NOT_EDIT.key]: EditLevelOptions.CAN_NOT_EDIT.properties,
    },
    reportLevelOptions: {
      [ReportLevelOptions.CANNOT_REPORT_BY_DEFAULT.key]: ReportLevelOptions.CANNOT_REPORT_BY_DEFAULT.properties,
      [ReportLevelOptions.CAN_REPORT.key]: ReportLevelOptions.CAN_REPORT.properties,
      [ReportLevelOptions.CAN_NOT_REPORT.key]: ReportLevelOptions.CAN_NOT_REPORT.properties,
    },
    deleteLevelOptions: {
      [DeleteLevelOptions.CANNOT_DELETE_BY_DEFAULT.key]: DeleteLevelOptions.CANNOT_DELETE_BY_DEFAULT.properties,
      [DeleteLevelOptions.CAN_DELETE.key]: DeleteLevelOptions.CAN_DELETE.properties,
      [DeleteLevelOptions.CAN_NOT_DELETE.key]: DeleteLevelOptions.CAN_NOT_DELETE.properties,
    },
    permissionsOptions: {
      [PermissionsOptions.CANNOT_BY_DEFAULT.key]: PermissionsOptions.CANNOT_BY_DEFAULT.properties,
      [PermissionsOptions.CAN.key]: PermissionsOptions.CAN.properties,
      [PermissionsOptions.CAN_NOT.key]: PermissionsOptions.CAN_NOT.properties,
    },
    avatarData: avatarData,
    selectedUsers: [],
    rules: {
        field: [
            (v) => !!v || 'Field is required',
        ],
        email: [
            (v) => !!v || 'Field is required',
            (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        password: [
            (v) => !!v || 'Password cannot be blank',
        ], 
    },
    selectAllStates: {
      viewLevel: 0,
      editLevel: 0,
      reportLevel: 0,
      deleteLevel: 0,
    },
    projectSubpermissions: [
      { name: 'Board',                      value: 0, },
      { name: 'Work Items',                 value: 2, },
      { name: 'Dashboard',                  value: 15, },
      { name: 'NucleiManagement',           value: 17, },
      { name: 'Account',                    value: 18, },
      { name: 'Healthchecks',               value: 19, },
      { name: 'Risks',                      value: 11, },
      { name: 'Links',                      value: 3, },
      { name: 'Team Members',               value: 14, },
      { name: 'Team Members Details',       value: 20, persistent: true },
      { name: 'General Details',            value: 1, },
      { name: 'Activity Log',               value: 10, },
      { name: 'Users Permissions',          value: 13, },
      { name: 'Config',                     value: 12, },
      { name: 'Overview',                   value: 16, },
    ],
    permissions: [],
    expandedPanel: null,
    selectedStatuses: [1],
    statuses: [],
    search: '',
  }),
  computed: {
    passwordRules(v) {
        return [
            (v) => !!v || !!this.id || 'Password cannot be blank',
        ]
    },
    confirmPasswordRules(v) {
        return [
            (v) => this.item.password === this.item.confirmPassword || 'Password confirmation must match with password.',
        ]
    },
    shownProjects() {
      let projects = this.projects
      projects = this.applySearch(this.search, projects, ['name', 'smallCode'])
      return projects.filter( p => {
        let hidden = this.selectedStatuses.indexOf(p.status) === -1
        return !hidden
      });
    },
  },
  created() {
    this.permissions = permissionsJSON.permissions
    this.$http
      .get(`/api/user`)
      .then(res => {
        this.users = res.data.filter(user => !user.type)
        this.users = _.orderBy(this.users, ['blueTag'])
      })
      .catch(res => {
        window.getApp.error("Cannot get users.")
        console.log(res)
      })
    let getCategoriesPromise = this.$http
      .get(`/api/category`)
      .then(res => {
        this.categories = res.data
        this.categories.forEach(c => this.$set(c, "viewLevel", parseInt(ViewLevelOptions.DEFAULT_KEY)))
      })
      .catch(res => {
        window.getApp.error("Cannot get categories.")
        console.log(res)
      })
    let getProjectsPromise = this.$http
      .get(`/api/userGroup/config/project`)
      .then(res => {
        this.projects = res.data
        this.projects.forEach(c => this.$set(c, "viewLevel", parseInt(ViewLevelOptions.DEFAULT_KEY)))
        this.projects.forEach(c => this.$set(c, "canEdit", parseInt(EditLevelOptions.DEFAULT_KEY)))
        this.projects.forEach(c => this.$set(c, "canReport", parseInt(ReportLevelOptions.DEFAULT_KEY)))
        this.projects.forEach(c => this.$set(c, "canDelete", parseInt(ReportLevelOptions.DEFAULT_KEY)))
      })
      .catch(res => {
        window.getApp.error("Cannot get projects.")
        console.log(res)
      })
    this.$http
      .get(`/api/Enums/ProjectStatus`)
      .then(res => {
        this.statuses = res.data;
      })
      .catch(res => {
        window.getApp.error("Cannot obtain project status.");
        console.log(res);
      });
    if (this.id) {
      this.$http
        .get(`/api/userGroup/${this.id}`)
        .then(res => {
          this.item = res.data

          const permissionsBase = this.permissions
            .map(x => x.children ? x.children : x)
            .flat(1)
          
          permissionsBase.forEach(x => {
            if(!this.item.permissions.some(p => p.type == x.value)){
              this.item.permissions.push({type: x.value, accessLevel: 0})
            }
          })

          document.title = 'Edit User Group (' + this.item.name + ')'
          this.selectedUsers = this.item.users.map(u => u.userId)
          getCategoriesPromise.then(() => {
            this.categories.forEach(c => {
              let ugCat = _.find(this.item.categories, ugc => ugc.categoryId === c.id)
              if (ugCat) {
                c.viewLevel = ugCat.viewLevel
              }
            })
          })
          getProjectsPromise.then(() => {
            this.projects.forEach(p => {
              let ugProj = _.find(this.item.projects, ugc => ugc.projectId === p.id)
              if (ugProj) {
                p.viewLevel = ugProj.viewLevel
                p.canEdit = ugProj.canEdit
                p.canReport = ugProj.canReport
                p.canDelete = ugProj.canDelete
                let tabs = p.tabs
                p.tabs = ugProj.viewableTabs.sort( (a, b) => a.tab < b.tab )
                p.tabs.forEach(tab => tab.show = (tabs.find(t => t.tab == tab.tab) || {}).active)
                p.userGroupProjectId = ugProj.id
              }
              else {
                let tabs = []
                for(let tab of p.tabs) {
                  tabs.push({
                    show: tab.active,
                    tab: tab.tab,
                    viewLevel: ViewLevelOptions.DEFAULT_KEY,
                  })
                }
                p.tabs = tabs.sort( (a, b) => a.tab < b.tab )
              }
            })
          })
        })
        .catch(res => {
          window.getApp.error("Cannot get record.")
          console.log(res)
        })
    } else {
      document.title = 'New User Group'
      getProjectsPromise.then(() => {
        this.projects.forEach(p => {
          let tabsQuantity = this.projectSubpermissions.length
          p.tabs = []
          for(let i = 0; i < tabsQuantity; i++) {
            p.tabs.push({ tab: i, userGroupProjectId: null, viewLevel: 0 })
          }
        })
      })
      for(let permission of this.permissions) {
        if(permission.children){
          for(let subpermission of permission.children){
            this.item.permissions.push({
              type: subpermission.value,
              accessLevel: 0,
            })
          }
        } else {
          this.item.permissions.push({
            type: permission.value,
            accessLevel: 0,
          })
        }
      }
    }
  },
  methods: {
    getPermissionByValue(value){
      if(!this.item.permissions){
        return {}
      }
      return this.item.permissions.find(p => p.type == value)
    },
    handleViewChange(project){
      project.viewLevel = this.viewLevelOptions[project.viewLevel].nextValue
      for(let tab of project.tabs){
        tab.viewLevel = project.viewLevel
      }
    },
    isCanPermission(permission){
      return permission == 3
    },
    selectAll(permission){
      const projectPermissions = {
        view: 'viewLevel',
        edit: 'canEdit',
        report: 'canReport',
        delete: 'canDelete',
      }
      for(let project of this.projects){
        project[projectPermissions[permission]] = this.selectAllStates[permission+'Level']
        if(permission == 'view'){
          for(let tab of project.tabs){
            tab.viewLevel = this.selectAllStates[permission+'Level']
          }
        }
      }
      this.selectAllStates[permission+'Level'] = this[permission+'LevelOptions'][this.selectAllStates[permission+'Level']].nextValue
    },
    remove(item) {
      const index = this.selectedUsers.indexOf(item.id)
      if (index >= 0) this.selectedUsers.splice(index, 1)
    },
    save() {
      this.item.canCreateProjects = this.item.permissions.find(p => p.type == 16)?.viewLevel
      this.item.canEditCategories = this.item.permissions.find(p => p.type == 13)?.viewLevel
      this.item.canEditUsers = this.item.permissions.find(p => p.type == 14)?.viewLevel || this.item.permissions.find(p => p.type == 15)?.viewLevel
      if (!this.$refs.form.validate()) return

      // Add transformed users and categories
      this.item.users = this.selectedUsers.map(id => ({
        userId: id
      }))
      this.item.categories = _(this.categories)
        .filter(c => c.viewLevel != -1)
        .map(c => ({
          categoryId: c.id,
          viewLevel: c.viewLevel,
        }))
        .value()
      this.item.projects = _(this.projects)
        // .filter(c => c.viewLevel != -1)
        .map(c => ({
          projectId: c.id,
          viewLevel: c.viewLevel,
          canEdit: c.canEdit,
          canReport: c.canReport,
          canDelete: c.canDelete,
          id: c.userGroupProjectId,
          userGroupId: this.item.id,
          viewableTabs: c.tabs,
        }))
        .value()
      this.$q.save({
        api: "/api/userGroup",
        data: this.item,
        successMsg: "User group saved.",
        afterSuccessUrl: "/userGroup",
        errorMsg: null,
        afterErrorUrl: null,
      })
        .catch(err => {
          console.error(err)
          if (err.response?.status !== 400) {
            this.$root.error('Cannot save user')
          }
        })
    },
    tabChange(project, index){
      project.tabs[index].viewLevel = this.viewLevelOptions[project.tabs[index].viewLevel].nextValue

      let allCant = true
      for(let tab of project.tabs){
        if(tab.viewLevel != 1){
          allCant = false
          break
        }
      }
      if(allCant){
        project.viewLevel = 1
      }
    }
  }
}
</script>

<style scoped lang="scss">
.line{
  margin-left: 10px;
  height: 45px;
  padding: 0 10px;
  border-radius: 3px;
  .line-title{
    font-size: 1.2em;
    display: inline-flex;
    align-items: center;
    height: 45px;
    color: #333;
  }
  .content{
    height: 45px;
    display: inline-flex;
    align-items: center;
    float: right;

    .item-title{
      display: inline-block;
      text-align: center;
      width: 72px;
      margin-left: 3px;
    }
  }  
}
.line:hover{
  background-color: var(--v-lightgray-lighten2);
}
.line.header:hover{
  background: transparent;
}
.line.header{
  margin-bottom: 5px;
  .line-title{
    font-size: 1em;
    color: #888;
  }
}

.panel-header{
  padding: 16px 24px;
  padding-right: 10px;
}

.panel-header:hover{
  background-color: var(--v-accent-lighten);
}
.panel-header::before{
  background-color: var(--v-accent-lighten);
}

::v-deep .v-expansion-panel-content__wrap{
  padding: 0;
}

::v-deep .v-expansion-panel-header__icon .v-icon {
  color: inherit !important;
}

.selected-project {
  margin: 5px;
  margin-left: 15px;
  padding-bottom: 5px;
  
  .panel-header{
    background-color: var(--v-accent-lighten);
  }
  .panel-header::before{
    opacity: 0 !important;
  }
  .panel-content {
    background-color: var(--v-background-lighten);
    padding-top: 5px;
  }
}

.panel-content{
  .line{
    margin: 0;
    height: 35px;
    padding: 0 50px;
    padding-right: 236px;
    border-radius: 3px;
    font-size: .9em;
  }
  .content{
    height: 35px;
  }
  .line-title{
    font-size: 1.2em;
    display: inline-flex;
    align-items: center;
    height: 35px;
    color: var(--v-text-lighten);
  }
}

.select-all-container{
  margin-bottom: 5px;
  border-bottom: 2px solid #ccc;
  .line-title{
    font-size: 1em;
    color: #888;
  }
  .item-title{
    cursor: pointer;
    display: inline-block;
    text-align: center;
    width: 72px;
    margin-left: 3px;
  }
}
.select-all-container:hover{
  background-color: transparent;
}

.permissions {
  .v-expansion-panel-header{
    padding: 5px 24px;
  }
  .panel-content{
    .line{
      margin: 0;
      height: 40px;
      padding: 0 50px;
      border-radius: 3px;
      font-size: .9em;
    }
    .content{
      height: 40px;
    }
    .line-title{
      font-size: 1.2em;
      display: inline-flex;
      align-items: center;
      height: 40px;
      color: var(--v-text-base);
    }
  }
}

.item-title{
  display: inline-block;
  text-align: center;
  width: 72px;
  margin-left: 3px;
}

.project-action-buttons {
  min-width: 179px;
  margin-right: 68px
}
.list-item{
  border-radius: 3px;
}
.list-item:hover{
  background: var(--v-lightgray-lighten2);
}
.project-toggle-btn.v-btn {
  min-width: 62px;
}

.main-subheader {
  flex: auto;
}

.right-title {
  display: inline-flex;
  width: 64px;
  text-align: center;
  font-size: 0.85em;
}

.v-tab {
  border-bottom: 2px solid gray;
  margin: 0px 10px;
  text-transform: capitalize;
  min-width: 150px;
}
</style>